import BotonCompartir from "./BotonCompartir";

export default function ObjetoCard({
  obj,
  usuario,
  onMarcarResuelto,
  onClickImagen,
}) {
  return (
    <article
      key={obj.id}
      id={`obj-${obj.id}`}
      className="card relative bg-white rounded-2xl shadow-md overflow-hidden transition hover:shadow-lg border"
    >
      <picture>
        {obj.imagen && (
          <img
            src={obj.imagen}
            alt={obj.descripcion}
            className="w-full max-h48 object-cover rounded cursor-pointer transition hover:opacity-90 rounded-b-none"
            onClick={() => onClickImagen(obj.imagen)}
            loading="lazy"
          />
        )}
      </picture>
      {obj.resuelto && (
        <span className="absolute top-3 right-3 bg-green-600 text-white text-xs px-2 py-1 rounded flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check mr-1 h-3 w-3"
          >
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
          Resuelto
        </span>
      )}

      <div className="p-4 space-y-2 relative">
        <div className="flex justify-between items-center">
          <span
            className={`text-xs font-semibold px-2 py-1 rounded-full ${
              obj.tipo === "perdido"
                ? "bg-red-100 text-red-700"
                : "bg-blue-100 text-blue-700"
            }`}
          >
            {obj.tipo === "perdido" ? "Perdido" : "Encontrado"}
          </span>
        </div>
        {!obj.resuelto && (
          <BotonCompartir id={obj.id} descripcion={obj.descripcion} />
        )}
        <p className="text-l text-gray-600 whitespace-pre-wrap">
          {obj.descripcion}
        </p>
        <hr className="" />
        <section className="flex flex-col gap-1 py-2">
          {obj.fecha && (
            <p className="text-sm text-gray-500 flex items-center" title="Día">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar-icon lucide-calendar h-4 w-4 mr-1"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
              </svg>{" "}
              {obj.fechaObjeto?.split("-").reverse().join("/") || obj.fecha}
            </p>
          )}
          {obj.lugar && (
            <p
              className="text-sm text-gray-500 flex items-center"
              title="Lugar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-4 w-4 mr-1 text-primary/70"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              {obj.lugar}
            </p>
          )}
          {obj.contacto && (
            <p
              className="text-sm text-blue-700 break-all items-center flex"
              title="Contacto"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-user-icon lucide-user w-4 h-4 mr-1"
              >
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>{" "}
              {obj.contacto}
            </p>
          )}
        </section>

        {!obj.resuelto && (
          <div className="grid grid-cols-2 gap-2 w-full">
            <a
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 bg-blue-500 text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full text-white"
              href={`tel:+549${obj.mobile}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-phone mr-2 h-4 w-4"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>{" "}
              Llamar
            </a>
            <a
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 py-2 w-full bg-green-500 hover:bg-[#128C7E] text-white"
              href={`https://api.whatsapp.com/send/?phone=549${obj.mobile}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"></path>
              </svg>{" "}
              WhatsApp
            </a>
          </div>
        )}
        {!obj.resuelto && (
          <button
            onClick={() => {
              const mobileIngresado = prompt(
                "Ingresá el número de móvil con el que hiciste el reporte (ej: 11XXXXXXXX):"
              );
              if (mobileIngresado && mobileIngresado.trim() === obj.mobile) {
                onMarcarResuelto(obj.id);
              } else {
                alert("El número ingresado no coincide.");
              }
            }}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-check mr-2 h-4 w-4"
            >
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
            Marcar como resuelto
          </button>
        )}
      </div>
    </article>
  );
}
